'use client';

import { useEffect } from 'react';
import { setCJAffiliateCookie } from 'commons/localStorage';

// Persist cjevent from affiliate landing URLs (legacy v2-consumer behavior).
const CjAffiliateTracking = () => {
  useEffect(() => {
    const persistCjEvent = () => setCJAffiliateCookie();

    persistCjEvent();
    window.addEventListener('jb:location-change', persistCjEvent);
    window.addEventListener('popstate', persistCjEvent);

    return () => {
      window.removeEventListener('jb:location-change', persistCjEvent);
      window.removeEventListener('popstate', persistCjEvent);
    };
  }, []);

  return null;
};

export default CjAffiliateTracking;
